export interface CompositeBackground {
  color?: string;
  imageUrl?: string;
}

export async function compositeScreenshot(
  modelCanvas: HTMLCanvasElement,
  background: CompositeBackground
): Promise<{ blob: Blob; dataURL: string }> {
  const { width, height } = modelCanvas;
  const offscreen = document.createElement('canvas');
  offscreen.width = width;
  offscreen.height = height;
  const ctx = offscreen.getContext('2d');
  if (!ctx) throw new Error('Could not get 2D canvas context');

  if (background.imageUrl) {
    await new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const scale = Math.min(width / img.width, height / img.height);
        const w = img.width * scale;
        const h = img.height * scale;
        const x = (width - w) / 2;
        const y = (height - h) / 2;
        ctx.drawImage(img, x, y, w, h);
        resolve();
      };
      img.onerror = () => reject(new Error('Failed to load background image'));
      img.src = background.imageUrl as string;
    });
  } else if (background.color) {
    ctx.fillStyle = background.color;
    ctx.fillRect(0, 0, width, height);
  }

  ctx.drawImage(modelCanvas, 0, 0);

  const dataURL = offscreen.toDataURL('image/png');
  const blob = await new Promise<Blob>((resolve, reject) => {
    offscreen.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('toBlob returned null'))),
      'image/png'
    );
  });

  return { blob, dataURL };
}
